import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "jobs" }
const _hoisted_2 = { class: "column" }
const _hoisted_3 = { class: "column" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Job = _resolveComponent("Job")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.first_col, (job, index) => {
        return (_openBlock(), _createBlock(_component_Job, {
          key: index,
          class: "job",
          job: job
        }, null, 8 /* PROPS */, ["job"]))
      }), 128 /* KEYED_FRAGMENT */))
    ]),
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.second_col, (job, index) => {
        return (_openBlock(), _createBlock(_component_Job, {
          key: index,
          class: "job",
          job: job
        }, null, 8 /* PROPS */, ["job"]))
      }), 128 /* KEYED_FRAGMENT */))
    ])
  ]))
}